// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--iH24G","copy_right":"Footer-module--copy_right--1Spjg","footer_link_list_container":"Footer-module--footer_link_list_container--24Acf"};